import React, { useState, useMemo } from "react";

// ✅ FRAGMENTS EXACTS de la plante (copié-collé strict)
const FragmentA = () => (
  <svg width="90" height="110" viewBox="110 15 65 90">
    <defs>
      <linearGradient id="leaf1GradFrag" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#6FCF97" />
        <stop offset="100%" stopColor="#27AE60" />
      </linearGradient>
      <filter id="glowFrag">
        <feGaussianBlur stdDeviation="2" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#glowFrag)">
      <path
        d="M 160 20 Q 140 25, 125 40 Q 115 55, 118 75 Q 125 92, 145 100 Q 158 104, 168 98 Q 175 85, 172 68 Q 168 45, 160 20 Z"
        fill="url(#leaf1GradFrag)"
        stroke="#1B5E20"
        strokeWidth="2.5"
      />
      <path d="M 160 20 Q 145 55, 142 98" stroke="#0D3D0D" strokeWidth="2" fill="none" opacity="0.7" />
      <path d="M 145 40 Q 130 45, 122 52" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 148 60 Q 133 65, 125 72" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 152 80 Q 138 85, 130 92" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
    </g>
  </svg>
);

const FragmentB = () => (
  <svg width="90" height="110" viewBox="175 45 90 100">
    <defs>
      <linearGradient id="leaf2GradFrag" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#81C784" />
        <stop offset="100%" stopColor="#4CAF50" />
      </linearGradient>
      <filter id="glowFrag2">
        <feGaussianBlur stdDeviation="2" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#glowFrag2)">
      <ellipse
        cx="220" cy="95" rx="38" ry="48"
        fill="url(#leaf2GradFrag)"
        stroke="#1B5E20"
        strokeWidth="2.5"
        transform="rotate(-20 220 95)"
      />
      <path d="M 220 50 L 220 140" stroke="#0D3D0D" strokeWidth="2.5" fill="none" opacity="0.7" transform="rotate(-20 220 95)" />
      <path d="M 220 65 Q 200 70, 190 75" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
      <path d="M 220 85 Q 200 90, 190 95" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
      <path d="M 220 105 Q 200 110, 190 115" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
      <path d="M 220 125 Q 200 130, 190 135" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
      <path d="M 220 65 Q 240 70, 250 75" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
      <path d="M 220 85 Q 240 90, 250 95" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
      <path d="M 220 105 Q 240 110, 250 115" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
      <path d="M 220 125 Q 240 130, 250 135" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(-20 220 95)" />
    </g>
  </svg>
);

const FragmentC = () => (
  <svg width="90" height="110" viewBox="60 100 80 95">
    <defs>
      <linearGradient id="leaf3GradFrag" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#A5D6A7" />
        <stop offset="100%" stopColor="#66BB6A" />
      </linearGradient>
      <filter id="glowFrag3">
        <feGaussianBlur stdDeviation="2" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#glowFrag3)">
      <path
        d="M 115 105 L 88 115 L 72 128 L 65 148 L 70 168 L 85 185 L 108 192 L 128 185 L 135 165 L 128 140 L 115 105 Z"
        fill="url(#leaf3GradFrag)"
        stroke="#1B5E20"
        strokeWidth="2.5"
      />
      <path d="M 115 105 L 100 160 L 95 185" stroke="#0D3D0D" strokeWidth="2" fill="none" opacity="0.7" />
      <path d="M 108 125 L 88 130" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 103 145 L 75 152" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 105 165 L 82 172" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 115 135 L 125 138" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 112 155 L 128 160" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
    </g>
  </svg>
);

const FragmentD = () => (
  <svg width="90" height="110" viewBox="55 190 90 95">
    <defs>
      <linearGradient id="leaf1GradFragD" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#6FCF97" />
        <stop offset="100%" stopColor="#27AE60" />
      </linearGradient>
      <filter id="glowFrag4">
        <feGaussianBlur stdDeviation="2" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#glowFrag4)">
      <path
        d="M 105 195 Q 85 200, 70 212 Q 58 228, 60 248 Q 68 268, 88 278 Q 108 283, 125 275 Q 138 263, 138 243 Q 132 220, 105 195 Z"
        fill="url(#leaf1GradFragD)"
        stroke="#1B5E20"
        strokeWidth="2.5"
      />
      <path d="M 105 195 Q 90 230, 92 275" stroke="#0D3D0D" strokeWidth="2" fill="none" opacity="0.7" />
      <path d="M 95 215 Q 78 222, 68 230" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 92 235 Q 73 242, 63 250" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 93 255 Q 77 262, 70 270" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 100 218 Q 118 222, 128 228" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 102 238 Q 120 242, 132 248" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
    </g>
  </svg>
);

const FragmentE = () => (
  <svg width="90" height="110" viewBox="180 210 85 95">
    <defs>
      <linearGradient id="leaf2GradFragE" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#81C784" />
        <stop offset="100%" stopColor="#4CAF50" />
      </linearGradient>
      <filter id="glowFrag5">
        <feGaussianBlur stdDeviation="2" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#glowFrag5)">
      <path
        d="M 210 215 Q 230 220, 245 232 Q 258 248, 258 268 Q 253 288, 235 298 Q 215 305, 198 298 Q 185 288, 185 268 Q 190 242, 210 215 Z"
        fill="url(#leaf2GradFragE)"
        stroke="#1B5E20"
        strokeWidth="2.5"
      />
      <path d="M 210 215 Q 222 250, 222 295" stroke="#0D3D0D" strokeWidth="2" fill="none" opacity="0.7" />
      <path d="M 218 235 Q 235 242, 245 250" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 220 255 Q 238 262, 250 270" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 220 275 Q 235 282, 245 290" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 218 240 Q 200 245, 192 252" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 220 260 Q 203 265, 195 272" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
    </g>
  </svg>
);

// ✅ PARASITES ressemblants (mêmes couleurs, styles similaires)
const FakeFragment1 = () => (
  <svg width="90" height="110" viewBox="0 0 80 100">
    <defs>
      <linearGradient id="fakeGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#6FCF97" />
        <stop offset="100%" stopColor="#27AE60" />
      </linearGradient>
      <filter id="glowFake1">
        <feGaussianBlur stdDeviation="2" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#glowFake1)">
      <path
        d="M 40 10 Q 22 18, 15 35 Q 12 55, 20 72 Q 35 85, 52 82 Q 65 75, 68 58 Q 65 35, 40 10 Z"
        fill="url(#fakeGrad1)"
        stroke="#1B5E20"
        strokeWidth="2.5"
      />
      <path d="M 40 10 Q 32 45, 35 80" stroke="#0D3D0D" strokeWidth="2" fill="none" opacity="0.7" />
      <path d="M 35 30 Q 22 35, 18 42" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 33 50 Q 20 55, 15 62" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
    </g>
  </svg>
);

const FakeFragment2 = () => (
  <svg width="90" height="110" viewBox="0 0 80 100">
    <defs>
      <linearGradient id="fakeGrad2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#81C784" />
        <stop offset="100%" stopColor="#4CAF50" />
      </linearGradient>
      <filter id="glowFake2">
        <feGaussianBlur stdDeviation="2" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#glowFake2)">
      <ellipse
        cx="42" cy="52" rx="26" ry="38"
        fill="url(#fakeGrad2)"
        stroke="#1B5E20"
        strokeWidth="2.5"
        transform="rotate(25 42 52)"
      />
      <path d="M 42 18 L 42 86" stroke="#0D3D0D" strokeWidth="2.5" fill="none" opacity="0.7" transform="rotate(25 42 52)" />
      <path d="M 42 32 Q 28 36, 22 42" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(25 42 52)" />
      <path d="M 42 52 Q 28 56, 22 62" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" transform="rotate(25 42 52)" />
    </g>
  </svg>
);

const FakeFragment3 = () => (
  <svg width="90" height="110" viewBox="0 0 80 100">
    <defs>
      <linearGradient id="fakeGrad3" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#A5D6A7" />
        <stop offset="100%" stopColor="#66BB6A" />
      </linearGradient>
      <filter id="glowFake3">
        <feGaussianBlur stdDeviation="2" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#glowFake3)">
      <path
        d="M 40 12 L 58 28 L 62 50 L 55 72 L 38 82 L 22 75 L 18 52 L 28 30 Z"
        fill="url(#fakeGrad3)"
        stroke="#1B5E20"
        strokeWidth="2.5"
      />
      <path d="M 40 12 L 40 80" stroke="#0D3D0D" strokeWidth="2" fill="none" opacity="0.7" />
      <path d="M 38 32 L 25 36" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 38 52 L 20 58" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
      <path d="M 42 38 L 56 42" stroke="#0D3D0D" strokeWidth="1.2" fill="none" opacity="0.5" />
    </g>
  </svg>
);

const FRAGMENTS = [
  { id: "a", Component: FragmentA, valid: true, code: "2" },
  { id: "b", Component: FragmentB, valid: true, code: "4" },
  { id: "c", Component: FragmentC, valid: true, code: "6" },
  { id: "d", Component: FragmentD, valid: true, code: "8" },
  { id: "e", Component: FragmentE, valid: true, code: "1" },
  { id: "fake1", Component: FakeFragment1, valid: false },
  { id: "fake2", Component: FakeFragment2, valid: false },
  { id: "fake3", Component: FakeFragment3, valid: false },
];

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export default function PlantFragmentPuzzle({ onSolved, storageKey }) {
  const [selected, setSelected] = useState(new Set());
  const [feedback, setFeedback] = useState("");
  const [solved, setSolved] = useState(() => {
    try {
      return localStorage.getItem(storageKey) === "1";
    } catch {
      return false;
    }
  });

  const shuffled = useMemo(() => shuffle(FRAGMENTS), []);

  const toggle = (id) => {
    if (solved) return;
    setFeedback("");
    setSelected((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const check = () => {
    const validIds = FRAGMENTS.filter((f) => f.valid).map((f) => f.id);
    const isCorrect = validIds.every((id) => selected.has(id)) && selected.size === validIds.length;

    if (isCorrect) {
      setSolved(true);
      const code = ["a", "b", "c", "d", "e"]
        .map((id) => FRAGMENTS.find((f) => f.id === id).code)
        .join("");

      setFeedback(`Fragments reconstitués !`);

      try {
        localStorage.setItem(storageKey, "1");
      } catch { }

      onSolved?.({ code });
    } else {
      setFeedback("❌ Ces fragments ne correspondent pas exactement à la plante...");
    }
  };

  return (
    <div className="space-y-4">
      <p className="text-xs text-slate-300">
        Une feuille avec plusieurs formes de feuilles dessinées...
      </p>

      <div className="rounded-xl border border-white/10 bg-black/30 p-4">
        <p className="text-[11px] uppercase tracking-wide text-slate-400 mb-3">
          Clique sur des formes pour les sélectionner
        </p>

        <div className="grid grid-cols-4 gap-3">
          {shuffled.map((frag) => {
            const isSelected = selected.has(frag.id);
            return (
              <button
                key={frag.id}
                onClick={() => toggle(frag.id)}
                disabled={solved}
                className={[
                  "aspect-square rounded-xl border-2 transition-all p-2",
                  "flex items-center justify-center",
                  isSelected
                    ? "border-emerald-400 bg-emerald-500/20 scale-95"
                    : "border-white/20 bg-white/5 hover:bg-white/10 hover:scale-105",
                  solved && "opacity-70 cursor-default",
                ].join(" ")}
              >
                <frag.Component />
              </button>
            );
          })}
        </div>

        <button
          onClick={check}
          disabled={solved || selected.size === 0}
          className="mt-4 w-full rounded-lg bg-indigo-600 hover:bg-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed py-2 text-xs font-semibold"
        >
          Vérifier
        </button>

        {feedback && (
          <p className={`mt-2 text-xs ${feedback.startsWith("✅") ? "text-emerald-300" : "text-amber-200"}`}>
            {feedback}
          </p>
        )}
      </div>

      {solved && (
        <div className="rounded-xl border border-emerald-400/30 bg-emerald-500/10 p-3">
          <p className="text-sm font-semibold text-emerald-200 mb-2">
            ✅ Ces fragments correspondent exactement aux feuilles de la plante ! Les morceaux sélectionnés vous indiquent le code du tiroir.
          </p>
          <p className="text-xs text-slate-300">
            Code du tiroir : <span className="font-bold text-emerald-100">24681</span>
          </p>
        </div>
      )}
    </div>
  );
}